module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0051.jpg?v=1517a5ea";